import { atom } from 'recoil';

const profileState = atom({
  key: 'profileState',
  default: {},
});

export default profileState;
